export default __webpack_public_path__ + "static/media/12-27.b0b26a49.png";